<template>
<div class="SWOT">
    <div class="Strengths">
        <h2>Strengths</h2>
        <ol v-if="sData.length > 0">
            <li 
            v-for="(response, index) in sData"
            :key="index">
            {{response}}
            </li>
        </ol>
        <ol v-else>
            <li>None found.</li>
        </ol>
    </div>
    <div class="Weaknesses">
        <h2>Weaknesses</h2>
        <ol v-if="wData.length > 0">
            <li 
            v-for="(response, index) in wData"
            :key="index">
            {{response}}
            </li>
        </ol>
        <ol v-else>
            <li>None found.</li>
        </ol>
    </div>
    <div class="Opportunities">
        <h2>Opportunities</h2>
        <ol v-if="oData.length > 0">
            <li 
            v-for="(response, index) in oData"
            :key="index">
            {{response}}
            </li>
        </ol>
        <ol v-else>
            <li>None found.</li>
        </ol>
    </div>
    <div class="Threats">
        <h2>Threats</h2>
        <ol v-if="tData.length > 0">
            <li 
            v-for="(response, index) in tData"
            :key="index">
            {{response}}
            </li>
        </ol>
        <ol v-else>
            <li>None found.</li>
        </ol>
    </div>
</div>
</template>

<script>
import { mapGetters } from "vuex";
import firebase from "firebase";
// import Question from './Question'

export default {
    name: 'SWOT',
    props: {
        sData: Array,
        wData: Array,
        oData: Array,
        tData: Array,
        sID: Number,
    },
    components: {
        // navbar
        // Question
        // Question
    },
    computed: {
        ...mapGetters({
    // map `this.user` to `this.$store.getters.user`
        user: "user"
        })
    },
    // methods: {
    //     submit(data) {
    //         console.log(data, this.user.data.uid, this.qID)
    //         // firebase.firestore()
    //         // .collection('sessions').doc(this.user.data.uid).set({
    //         //     QID: this.qID,
    //         //     answer: data
    //         // })
    //         // .catch(err => {
    //         // this.error = err.message;
    //         // });
            
    //     },
    //     handleNextQuestion(data) {
	// 		console.log("advance")
	// 		this.responses[this.progress] = data;
	// 		this.progress += 1;
	// 		// if (this.section >= this.sections.length) {
	// 		// 	this.showResults = true;
	// 		// }
	// 		// console.log("results", this.results)
    //     },
    //     beginSection() {
    //         console.log("begin")
    //         this.progress = 0;
    //     },
    //     completeSection() {
    //         let storeSection = 'section' + this.sID
    //         console.log("complete")
    //         firebase.firestore()
    //         .collection(storeSection).doc(this.user.data.uid).set({
    //             responses: this.responses
    //         })
    //         .catch(err => {
    //         this.error = err.message;
    //         });
    //         this.$emit("nextSection")
    //     },
    //     debugSection() {
    //         console.log(this.responses)
    //         // console.log(this.sData)
    //     }
    // },
  data () {
    return {
    //   progress: -1,
    //   responses: []
    }
  }
}
</script>

<style>
.SWOT {
    display: flex;
    flex-direction: column;
    /* flex-wrap: wrap; */
}

.Strengths {
    display: block;
    min-width: 50%; 
    background-color: rgba(#1bb598, .15) !important;
}

.Weaknesses {
    display: block;
    min-width: 50%; 
    background-color: rgba(#ffb340, .15) !important;

}

.Opportunities {
    display: block;
    min-width: 50%; 
    background-color: rgba(#3eb6b6, .15) !important;

}

.Threats {
    display: block;
    min-width: 50%; 
    background-color: rgba(#e24c4c, .15) !important;
    
}

</style>